<template>
    <AppLayout
        ref="layout"
        page="/dashboard"
        :pageTitle="title"
        backLink="/dashboard/reports"
    >
        <v-list-item-subtitle
            v-if="can('View admin reports')"
            class="font-bold pa-4 pt-0"
            style="white-space: normal"
            ><v-btn
                x-small
                outlined
                class="soli-round soli-blue-text"
                :href="`/dashboard/reports/${attribute}-performance?allLocations=${
                    allLocations ? 0 : 1
                }`"
                >{{
                    allLocations
                        ? `View ${$page.props.auth.user.selected_location.name}`
                        : `View All Locations`
                }}</v-btn
            >
        </v-list-item-subtitle>
        <v-row>
            <v-col v-for="item in items" :key="item.id" cols="12" lg="6" xl="4">
                <v-card class="soli-round">
                    <v-container fluid>
                        <v-card-title
                            class="pb-0 soli-grey"
                            style="max-height: 64px; position: relative"
                        >
                            {{ item.title }} <v-spacer />
                            <v-btn icon @click="item.showStatsHelp = true"
                                ><v-icon color="primary">help</v-icon></v-btn
                            ></v-card-title
                        >
                        <v-tabs v-model="item.tab" class="custom-tabs px-4">
                            <v-tab
                                v-for="stat in stats"
                                :key="stat.title"
                                :disabled="stat.disabled"
                            >
                                {{ stat.title }}
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="item.tab" touchless>
                            <v-tab-item
                                v-for="(stat, idx) in stats"
                                :key="stat.title"
                                :class="{
                                    'stat-with-options': stat.hasOptions,
                                }"
                                :transition="false"
                                style="min-height: 304px"
                            >
                                <AttributeStat
                                    v-if="idx == item.tab"
                                    :attribute="attribute"
                                    :value="item"
                                    :showStatsHelp="item.showStatsHelp"
                                    :metric="stat.slug"
                                    :table="stat.table"
                                    :defaultOption="stat.defaultOption"
                                    :help="stat.help"
                                    :allLocations="allLocations"
                                    @selectOption=""
                                    @rendered="redrawVueMasonry"
                                    @reset="
                                        closeModal(
                                            () => (item.showStatsHelp = false)
                                        )
                                    "
                                    class="animate__animated animate__fadeIn"
                                />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import AttributeStat from "@/Components/Reports/AttributeStat.vue";

export default {
    components: {
        AppLayout,
        AttributeStat,
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        attribute: {
            type: String,
            default: "",
        },
        items: {
            type: Array,
            default: () => [],
        },
        defaultOption: {
            type: String,
        },
        allLocations: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        redrawVueMasonry() {
            for (let i = 0; i <= 350; i += 350) {
                setTimeout(() => {
                    this.$redrawVueMasonry();
                }, i);
            }
        },
    },
    computed: {
        stats() {
            return [
                {
                    title: "Retention",
                    slug: "retention",
                    defaultOption: "retention",
                    disabled: false,
                    table: false,
                },
                {
                    title: "Conversion",
                    slug: "conversion",
                    defaultOption: "conversion",
                    disabled: false,
                    table: false,
                },
                {
                    title: "Attendance",
                    slug: "attendance",
                    defaultOption: "attendance",
                    disabled: false,
                    hasOptions: true,
                    table: false,
                },
                /*{
                    title: "Teachers",
                    slug: "teachers",
                    defaultOption: null,
                    disabled: false,
                    hasOptions: false,
                    table: true,
                },*/
            ];
        },
    },
};
</script>
